__turbopack_context__.v({
  "active": "search-header-mobile-module-scss-module__tMbEsG__active",
  "auth": "search-header-mobile-module-scss-module__tMbEsG__auth",
  "back-icon": "search-header-mobile-module-scss-module__tMbEsG__back-icon",
  "bar": "search-header-mobile-module-scss-module__tMbEsG__bar",
  "bar-container": "search-header-mobile-module-scss-module__tMbEsG__bar-container",
  "component": "search-header-mobile-module-scss-module__tMbEsG__component",
  "is-hidden": "search-header-mobile-module-scss-module__tMbEsG__is-hidden",
  "is-visible": "search-header-mobile-module-scss-module__tMbEsG__is-visible",
  "layout-container": "search-header-mobile-module-scss-module__tMbEsG__layout-container",
  "location-search": "search-header-mobile-module-scss-module__tMbEsG__location-search",
  "menu": "search-header-mobile-module-scss-module__tMbEsG__menu",
  "navigation": "search-header-mobile-module-scss-module__tMbEsG__navigation",
  "search-wrapper": "search-header-mobile-module-scss-module__tMbEsG__search-wrapper",
  "user": "search-header-mobile-module-scss-module__tMbEsG__user",
  "user-dropdown": "search-header-mobile-module-scss-module__tMbEsG__user-dropdown",
  "x": "search-header-mobile-module-scss-module__tMbEsG__x",
});
